import { Clerk } from "@clerk/clerk-js";

const publishableKey = process.env.VUE_APP_CLERK_PUBLISHABLE_KEY || "";

let clerkPromise = null;
let clerkInstance = null;

export const isClerkConfigured = Boolean(publishableKey);

export async function getClerk() {
  if (!isClerkConfigured) {
    throw new Error("VUE_APP_CLERK_PUBLISHABLE_KEY mancante.");
  }

  if (clerkInstance) {
    return clerkInstance;
  }

  if (!clerkPromise) {
    clerkPromise = (async () => {
      const clerk = new Clerk(publishableKey);
      await clerk.load();
      clerkInstance = clerk;
      return clerk;
    })();
  }

  return clerkPromise;
}

export async function getClerkToken() {
  const clerk = await getClerk();
  if (!clerk.session) {
    return null;
  }
  return clerk.session.getToken();
}

export async function signOutFromClerk(redirectUrl) {
  if (!isClerkConfigured) {
    return;
  }

  const clerk = await getClerk();
  if (clerk.isSignedIn) {
    await clerk.signOut(redirectUrl ? { redirectUrl } : undefined);
  }
}

export function getClerkProfile(clerk) {
  const user = clerk?.user;
  const primaryEmail = user?.primaryEmailAddress?.emailAddress || "";

  return {
    email: primaryEmail,
    first_name: user?.firstName || "",
    last_name: user?.lastName || "",
  };
}
